// 智能客服路由
export const customerServiceMain = [
  {
    name: 'customerService',
    path: '/customer_service',
    meta: {
      title: '智能客服',
      icon: 'el-icon-service'
    }
  },
  {
    name: 'customerServiceFaq',
    path: '/customer_service/faq',
    component: () => import('/@/views/plugins/customer_service/Faq.vue'),
    meta: {
      title: 'FAQ 管理',
      icon: 'el-icon-document',
      plugin: 'customer_service',
      keepAlive: true
    }
  },
  {
    name: 'customerServiceSession',
    path: '/customer_service/session',
    component: () => import('/@/views/plugins/customer_service/Session.vue'),
    meta: {
      title: '会话记录',
      icon: 'el-icon-chat-dot-round',
      plugin: 'customer_service'
    }
  },
  {
    name: 'customerServiceSettings',
    path: '/customer_service/settings',
    component: () => import('/@/views/plugins/customer_service/Settings.vue'),
    meta: {
      title: '客服设置',
      icon: 'el-icon-setting',
      plugin: 'customer_service'
    }
  }
]

export default customerServiceMain

